function getCurrentLocale() {
  return document.documentElement.getAttribute('lang');
}

export default getCurrentLocale;
